import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import ClickAwayListener from "@mui/core/ClickAwayListener";
import CloseIcon from "@mui/icons-material/Close";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import HotelIcon from "@mui/icons-material/Hotel";
import { IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import LinearProgress from "@mui/material/LinearProgress";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Radio from "@mui/material/Radio";
import moment from "moment";
import { ImUser } from "react-icons/im";
import { addRecentAirport } from "utils/recentAirports";
import { capitalizeFirstLetter } from "utils/Utils";

import "./style.css";

import BannerInput from "../bannerInput";
import MainButton from "../button";
import DatePicker from "../datePicker";
import DropDown from "../dropDown";
import AppListItem from "../listItem";
import Modal from "../swipeDrawer";

import { ReactComponent as Airplate } from "assets/images/airplate.svg";
import { ReactComponent as Children } from "assets/images/children.svg";
import { ReactComponent as Infants } from "assets/images/infants.svg";
import { ReactComponent as MultiCity } from "assets/images/multiCity.svg";
import { ReactComponent as Nomed } from "assets/images/nomed.svg";
import { ReactComponent as OneWay } from "assets/images/oneWay.svg";
import { ReactComponent as Return } from "assets/images/return.svg";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SwitchLeftIcon from "@mui/icons-material/SwitchLeft";

import { getAirportByIataCode } from "api/Airport";
import useApi from "hooks/useApi";
import { useTranslation } from "i18n";
import { checkISAdminOrEmployee } from "utils/Utils";

import AirportMobileList from "./airport-mobile-list";

import HotelsTab from "./search-tabs/hotels-tab";
import CarsTab from "./tabs/cars-tab";

import BannerInputSection from "./banner-input";

//----------------------------------------------------------------

const QUICK_ROUTES = [
  {
    id: "ams-pbm",
    origin: { cityCode: "AMS", cityName: "Amsterdam" },
    destination: { cityCode: "PBM", cityName: "Paramaribo" },
  },
  {
    id: "pbm-ams",
    origin: { cityCode: "PBM", cityName: "Paramaribo" },
    destination: { cityCode: "AMS", cityName: "Amsterdam" },
  },
  {
    id: "ams-dxb",
    origin: { cityCode: "AMS", cityName: "Amsterdam" },
    destination: { cityCode: "DXB", cityName: "Dubai" },
  },
  {
    id: "pbm-cur",
    origin: { cityCode: "PBM", cityName: "Paramaribo" },
    destination: { cityCode: "CUR", cityName: "Curacao" },
  },
  {
    id: "pbm-mia",
    origin: { cityCode: "PBM", cityName: "Paramaribo" },
    destination: { cityCode: "MIA", cityName: "Miami" },
  },
];

const Banner = ({
  departureDate,
  setdepartureDate,
  returnDate,
  setReturnDate,
  handleExplore,
  hideFilter,
  airlinesCodes,
  airlineCarrier,
  includedCarrierCodes,
  onChangeCarrier,
  activeTabProp = "flights",
  allFilters,
  setAllFilters,
  isSearchable,
  setRedirectLink,
  loading,
  showQuickRoutes = false,
  compact = false,
  presetRoute = null,
}) => {
  const { search } = useLocation();
  let searchParams = new URLSearchParams(search);
  const { t } = useTranslation();

  const [show, setShow] = useState(false);
  const [flightId, setFlightID] = useState(0);
  const [activeTab, setActiveTab] = useState(activeTabProp);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeList, setActiveList] = useState(true);
  const [refundableFare, setRefundableFare] = useState(false);
  const [quickRoutesOpen, setQuickRoutesOpen] = useState(false);

  const [tabs, setTabs] = useState(["Flights", "Hotels"]);
  const [checkedBag, setCheckedBag] = useState(false);

  const [originLocationCode, setOriginLocationCode] = useState({
    cityCode: searchParams.get("origin") ? searchParams.get("origin") : "",
    cityName: searchParams.get("origin")?.split("/")[1] ?? "",
  });
  const [destinationLocationCode, setDestinationLocationCode] = useState({
    cityCode: searchParams.get("destination") ?? "",
    cityName: searchParams.get("destination")?.split("/")[1] ?? "",
  });

  const [classKey, setClassKey] = useState("ECONOMY");
  const [keyword, setKeyword] = useState("");
  const [keyword2, setKeyword2] = useState("");
  let navigate = useNavigate();

  const getAirportByIataCodeApi = useApi(getAirportByIataCode, {
    cancelInflight: true,
  });
  const getAirportByIataCodeApi2 = useApi(getAirportByIataCode, {
    cancelInflight: true,
  });

  useEffect(() => {
    if (keyword.length >= 2) {
      getAirportByIataCodeApi.request({ keyword });
    }
    if (keyword2.length >= 2) {
      getAirportByIataCodeApi2.request({ keyword: keyword2 });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
  }, [keyword, keyword2]);

  const toggleDrawer = (open, type, id, fieldType) => (event) => {
    if (type) {
      setActiveList(type);
    }
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    if (fieldType === "departure") {
      setShow("dateFrom");
    } else {
      setShow("dateTo");
    }

    if (id) {
      setFlightID(id);
    }
    setOpenDrawer(open);
  };

  const [returnOption, setReturnOption] = useState({
    currentOption: searchParams.get("flight") ?? "Return",
    options: [
      { id: 1, value: "Return", key: "Return", labelKey: "banner.return" },
      { id: 2, value: "One-way", key: "One-way", labelKey: "banner.oneWay" },
      {
        id: 3,
        value: "Multi-city",
        key: "Multi-city",
        labelKey: "banner.multiCity",
      },
    ],
  });

  const [classOption, setClassOption] = useState({
    currentOption: searchParams.get("cabinType") ?? "Economy",
    options: [
      {
        id: 1,
        value: "Economy",
        labelKey: "banner.economy",
        key: "ECONOMY",
        checked: false,
      },
      {
        id: 2,
        value: "Premium Economy",
        labelKey: "banner.premiumEconomy",
        key: "PREMIUM_ECONOMY",
        checked: false,
      },
      {
        id: 3,
        value: "Business",
        labelKey: "banner.business",
        key: "BUSINESS",
        checked: false,
      },
      {
        id: 4,
        value: "First Class",
        labelKey: "banner.firstClass",
        key: "FIRST",
        checked: false,
      },
    ],
  });

  const [rooms, setRooms] = useState([
    { value: "Adult", labelKey: "banner.adult", key: "adult", num: 1 },
    {
      value: "Children",
      labelKey: "banner.children",
      key: "children",
      num: 0,
      childAge: [],
    },
    {
      value: "How many Rooms",
      labelKey: "banner.howManyRooms",
      key: "rooms",
      num: 1,
    },
  ]);

  const [infoSource, setInfoSource] = useState({
    selected: searchParams.get("infoSource") ?? "Distribution",
    options: [
      {
        value: "Distribution",
        label: "Distribution",
      },
      {
        value: "Leisure",
        label: "Leisure",
      },
      {
        value: "MultiSource",
        label: "MultiSource",
      },
    ],
  });

  const [stops, setStops] = useState({
    currentOption: {
      id: 1,
      value: "Non Stop(direct)",
      labelKey: "filters.nonStop",
      key: 0,
      checked: false,
    },
    options: [
      {
        id: 1,
        value: "Non Stop(direct)",
        labelKey: "filters.nonStop",
        key: 0,
        checked: false,
      },
      {
        id: 2,
        value: "Up to 1 stop",
        labelKey: "filters.upToOneStop",
        key: 1,
        checked: false,
      },
      {
        id: 3,
        value: "Up to 2 stop",
        labelKey: "filters.upToTwoStops",
        key: 2,
        checked: false,
      },
    ],
  });

  const getSpecificFilter = (label) => {
    const filter = allFilters?.find((filter) => filter.label === label);
    return filter;
  };

  const changeStops = (item) => {
    setStops({ ...stops, currentOption: item });

    handleUpdateFilters(getSpecificFilter("Stops"), item);
  };

  const changeType = (item, type) => {
    setReturnOption({ ...returnOption, currentOption: item.value });
    if (item.value === "Multi-city") {
      handleAddDestination();
    } else {
      clearFlightDetails();
    }
    // setReturnDate("");
    if (hideFilter) {
      if (item.value === "Return") {
        if (type === "mobile") {
          toggleDrawer(true, "calendar");
        } else {
          setTimeout(() => setShow("dateTo"), 500);
          window.scrollTo(0, 0);
        }
      }
    }
  };

  const changeClass = (item) => {
    setClassOption({ ...classOption, currentOption: item.value });
    setClassKey(item.key);
    handleUpdateFilters(getSpecificFilter("Cabin Type"), item);
  };

  const chooseType = (type) => {
    const obj = {
      Return: <Return />,
      "One-way": <OneWay />,
      "Multi-city": <MultiCity />,
    };
    return obj[type] ?? <Nomed />;
  };

  const translateOption = (option) => (option?.labelKey ? t(option.labelKey) : option?.value);

  const translateTab = (tab) => {
    const tabKeys = {
      flights: "banner.flights",
      hotels: "banner.hotels",
    };

    return t(tabKeys[tab.toLocaleLowerCase()]) || tab;
  };

  //choose the screen size
  const handleResize = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const [passerngersType, setPassengerType] = useState([
    {
      value: "Senior",
      labelKey: "banner.senior",
      subTitle: "60+",
      num: +searchParams.get("Senior") || 0,
    },
    {
      value: "Adults",
      labelKey: "banner.adults",
      subTitle: "Over 11",
      num: +searchParams.get("Adults") || 1,
    },
    {
      value: "Children",
      labelKey: "banner.children",
      subTitle: "2-11",
      num: +searchParams.get("Children") || 0,
    },
    {
      value: "Infants",
      labelKey: "banner.infants",
      subTitle: "Under 2",
      num: +searchParams.get("Infants") || 0,
    },
  ]);

  const [bagsType, setBags] = useState([
    { value: "Checked baggage", labelKey: "banner.checkedBaggage" },
  ]);

  const onClickMinus = (index, pass) => {
    if (pass) {
      if (passerngersType[index].num > 0) {
        const newItems = [...passerngersType];
        passerngersType[index].num = passerngersType[index].num - 1;
        setPassengerType(newItems);
      }
    }
  };

  const onClickPlus = (value, pass) => {
    let currentPassenger = passerngersType?.find(
      (passer) => passer.value == value
    )?.num;

    if (pass) {
      if (
        (value === "Senior" && currentPassenger >= 9) ||
        (value === "Adults" && currentPassenger >= 9) ||
        (value === "Infants" &&
          currentPassenger >=
            passerngersType?.find((passer) => passer.value === "Adults")?.num)
      ) {
        return;
      } else {
        setPassengerType((prev) => {
          const newItems = [...prev];
          newItems.find((i) => i.value === value).num = currentPassenger + 1;
          return newItems;
        });
      }
    }
  };

  const getNumOFRoomDetails = (type) => {
    const num = rooms.find((room) => room.key === type);

    if (type === "children") {
      return num?.childAge;
    }
    return num?.num;
  };

  const redirectSearch = (e) => {
    let link = "";

    const getHotelDetails = multiCity[0];

    if (activeTab === "hotels") {
      const params = new URLSearchParams({
        destination: destinationLocationCode.cityCode,
        startDate: moment(getHotelDetails.originDate).format("YYYY-MM-DD"),
        endDate: moment(getHotelDetails.destinationDate).format("YYYY-MM-DD"),
        guestCount: getNumOFRoomDetails("adult"),
        children: getNumOFRoomDetails("children"),
        roomStayCandidate: getNumOFRoomDetails("rooms"),
        infoSource: infoSource.selected,
      });

      link = `/hotels?${params.toString()}`;
    } else {
      const origin = multiCity
        .map((flight) => `${flight.origin.cityCode}-${flight.origin.cityName}`)
        .join("~");

      const destination = multiCity
        .map(
          (flight) =>
            `${flight.destination.cityCode}-${flight.destination.cityName}`
        )
        .join("~");

      const originsDates = multiCity
        .map((i) => moment(i.originDate).format("YYYY-MM-DD"))
        .join("~");

      const destinationDates =
        returnOption.currentOption === "Return"
          ? multiCity
              .map((i) => moment(i.destinationDate).format("YYYY-MM-DD"))
              .join("~")
          : null;

      const params = new URLSearchParams();

      params.set("origin", origin);
      params.set("destination", destination);
      params.set("Senior", passerngersType[0].num);
      params.set("Adults", passerngersType[1].num);

      if (passerngersType[2].num > 0) {
        params.set("Children", passerngersType[2].num);
      }

      if (passerngersType[3].num > 0) {
        params.set("Infants", passerngersType[3].num);
      }

      params.set("flight", returnOption.currentOption);
      params.set("departure-date", originsDates);

      if (destinationDates) {
        params.set("return-date", destinationDates);
      }

      // Optional filters
      if (getFilterBySelectedKey("cabinType")) {
        params.set("cabinType", getFilterBySelectedKey("cabinType"));
      }

      if (getFilterBySelectedKey("stops")) {
        params.set("stops", getFilterBySelectedKey("stops"));
      }

      if (getFilterBySelectedKey("refundableFare")) {
        params.set("refundableFare", getFilterBySelectedKey("refundableFare"));
      }

      if (getFilterBySelectedKey("checkedbaggage")) {
        params.set("checkedbaggage", getFilterBySelectedKey("checkedbaggage"));
      }

      if (getFilterBySelectedKey("satyamSpecial")) {
        params.set("satyamSpecial", getFilterBySelectedKey("satyamSpecial"));
      }

      if (getFilterBySelectedKey("officeId")) {
        params.set("officeId", getFilterBySelectedKey("officeId"));
      }

      link = `/search?${params.toString()}`;

      if (hideFilter) {
        const getOriginsDates = originsDates.split("~")[0];
        const getDestinationDates =
          returnOption.currentOption === "Return"
            ? destinationDates?.split("~")[0]
            : returnOption.currentOption === "One-way"
            ? originsDates.split("~")[0]
            : originsDates.split("~").slice(-1)[0];

        handleExplore(
          getOriginsDates,
          getDestinationDates,
          originLocationCode,
          destinationLocationCode
        );
      } else {
        e.preventDefault();
      }
    }

    navigate(link);
    window.scrollTo(0, 0);
    setRedirectLink(link);
  };

  const getFilterBySelectedKey = (filterName) => {
    if (filterName === "checkedbaggage") {
      const getFilter = allFilters?.find((filter) => filter.multiple);
      const getKey = getFilter.options.find(
        (option) => option.value === "Checked baggage"
      );
      return getKey.key;
    } else if (filterName === "satyamSpecial") {
      const getFilter = allFilters?.find((filter) => filter.multiple);
      const getKey = getFilter.options.find(
        (option) => option.value === "2x Checked baggage"
      );
      // `key` is a static string ("PUBLISHED") that never flips when the option
      // is toggled, so derive the fare type from the live checked state instead.
      return getKey?.checked ? "NEGOTIATED" : getKey?.defaultOption;
    } else if (filterName === "refundableFare") {
      const getFilter = allFilters?.find((filter) => filter.key === filterName);
      return getFilter.options[0].key;
    } else {
      const getFilter = allFilters?.find((filter) => filter.key === filterName);

      const getKey = getFilter?.options?.find((option) => option.checked);

      if (getKey) return getKey.key;
      return getFilter?.defaultOption;
    }
  };

  const handleUpdateFilters = (currentFilter, selectedOption) => {
    const oldState = [...allFilters];

    const findOptionsOFFilter = allFilters?.find(
      (filter) => filter.key === currentFilter.key
    )?.options;

    let checkParam =
      typeof selectedOption.key === "boolean"
        ? !selectedOption.key
        : selectedOption.key;

    findOptionsOFFilter?.forEach((item) => {
      if (item.value === selectedOption.value) {
        // Special logic for specific filter types
        if (!currentFilter.key) {
          if (item.value === "Checked baggage") {
            searchParams.set("checkedbaggage", !item.checked);
          } else if (item.value === "2x Checked baggage") {
            checkParam = item.checked ? "PUBLISHED" : "NEGOTIATED";
            item.key = checkParam;
            searchParams.set("satyamSpecial", checkParam);
          }
        }

        item.checked = !item.checked;

        if (typeof selectedOption.key === "boolean") {
          item.key = checkParam;
        }
      } else if (currentFilter.key) {
        item.checked = false;
      }
    });

    // If flight type is one-way, remove return-date param
    if (selectedOption.key === "One-way") {
      searchParams.delete("return-date");
      setReturnDate("");
    }

    // Handle search param update
    if (currentFilter.key) {
      const existingValue = searchParams.get(currentFilter.key);
      if (existingValue === String(checkParam)) {
        searchParams.set(currentFilter.key, currentFilter.defaultOption);
      } else {
        searchParams.set(currentFilter.key, String(checkParam));
      }
    }

    // ✅ Update URL using correct string format for v6.2.1
    if (hideFilter) {
      navigate(`/search?${searchParams.toString()}`);
    }

    // Update filters state
    setAllFilters(oldState);
  };

  const list = () => (
    <Box
      sx={{
        width: "auto",
        height:
          activeList === "departure" || activeList === "return-flight"
            ? "100vh"
            : "auto",
      }}
      display="flex"
      flexDirection="column"
      role="presentation"
    >
      {activeList === "pass" ? (
        <List
          sx={{ px: 2, mb: 10, mt: 2, overflowY: "scroll", height: "85vh" }}
        >
          <div className="mb-24">
            <h2 className="medium-font-size">{t("banner.passengers")}</h2>
            {passerngersType.map((item, index) => (
              <AppListItem
                key={index}
                index={index}
                title={translateOption(item)}
                subTitle={item.subTitle}
                Icon={index === 0 ? ImUser : index === 1 ? Children : Infants}
                num={item.num}
                onClickMinus={() => onClickMinus(index, "pass")}
                onClickPlus={() => onClickPlus(item.value, "pass")}
                pass
              />
            ))}
          </div>

          {allFilters?.map((filter, index) =>
            !filter?.permission ? (
              <>
                <h2 key={index} className="medium-font-size">
                  {filter.labelKey ? t(filter.labelKey) : filter.label}
                </h2>
                <div className="mb-24">
                  {filter.options.map((item, index) => (
                    <ListItem key={index} sx={{ px: 0, py: 0 }}>
                      <ListItemText
                        primary={item.labelKey ? t(item.labelKey) : item.value}
                        className="list-item-text"
                      />
                      <Radio
                        onClick={() => {
                          handleUpdateFilters(filter, item);
                        }}
                        checked={item.checked}
                        color="default"
                      />
                    </ListItem>
                  ))}
                  {allFilters?.length !== index + 1 && <hr />}
                </div>
              </>
            ) : (
              checkISAdminOrEmployee() && (
                <>
                  <h2 key={index} className="medium-font-size">
                    {filter.labelKey ? t(filter.labelKey) : filter.label}
                  </h2>
                  <div className="mb-24">
                    {filter.options.map((item, index) => (
                      <ListItem key={index} sx={{ px: 0, py: 0 }}>
                        <ListItemText
                            primary={item.labelKey ? t(item.labelKey) : item.value}
                          className="list-item-text"
                        />
                        <Radio
                          onClick={() => {
                            handleUpdateFilters(filter, item);
                          }}
                          checked={item.checked}
                          color="default"
                        />
                      </ListItem>
                    ))}
                  </div>
                  <hr />
                </>
              )
            )
          )}

          {hideFilter && (
            <Box my={1}>
              <h2 className="medium-font-size">{t("search.airlineCarriers")}</h2>
              {airlinesCodes?.map((item, index) => (
                <ListItem
                  onClick={() => onChangeCarrier(item)}
                  key={index}
                  sx={{ px: 0, py: 0 }}
                >
                  <img
                    className="results-card-logo logos-collapse"
                    src={airlineCarrier[item]?.carrierLogo[0]?.squareImage}
                  />
                  <ListItemText
                    primary={capitalizeFirstLetter(
                      airlineCarrier[item]?.carrierName
                    )}
                    className="list-item-text"
                  />
                  <Radio
                    checked={includedCarrierCodes?.includes(item)}
                    color="default"
                  />
                </ListItem>
              ))}
            </Box>
          )}
        </List>
      ) : activeList === "return" ? (
        <List>
          {returnOption.options.map((item, index) => (
            <ListItem
              onClick={() => {
                changeType(item, "mobile");
              }}
              key={index}
            >
              <ListItemIcon>{chooseType(item.value)}</ListItemIcon>
              <ListItemText primary={translateOption(item)} />
              <Radio
                checked={item.value === returnOption.currentOption}
                color="default"
              />
            </ListItem>
          ))}
        </List>
      ) : activeList === "calendar" ? (
        <DatePicker
          setReturnDate={setReturnDate}
          isMobile={isMobile}
          toggleDrawer={toggleDrawer(false)}
          returnDate={returnDate}
          departureDate={
            multiCity?.find((flight) => flight.id === flightId)?.originDate
          }
          flightType={returnOption.currentOption}
          disabled={returnOption.currentOption !== "Return"}
          setdepartureDate={(date) => {
            handelUpdateFlightsData({
              id: flightId,
              key: "originDate",
              value: date,
            });
          }}
          dateDifference={moment(
            multiCity?.find((flight) => flight.id === flightId)?.originDate
          ).diff(moment(multiCity[flightId - 2]?.originDate), "days")}
          onSelect={(dates) => {
            handelUpdateFlightsData({
              id: flightId,
              key: "originDate",
              value: dates.startDate,
            });
            handelUpdateFlightsData({
              id: flightId,
              key: "destinationDate",
              value: dates.endDate,
            });
          }}
          show={show}
          setShow={setShow}
        />
      ) : activeList === "departure" ? (
        <AirportMobileList
          placeholder={t("banner.from")}
          onItemClick={(item) => {
            setKeyword(item?.cityName);
            setOriginLocationCode(item);
            setOpenDrawer(false);

            handelUpdateFlightsData({
              id: flightId,
              key: "origin",
              value: item,
            });
          }}
          keyword={keyword}
          airports={getAirportByIataCodeApi}
          setKeyword={setKeyword}
          excludeCityCode={
            multiCity?.find((flight) => flight.id === flightId)?.destination
              ?.cityCode
          }
        />
      ) : (
        <AirportMobileList
          placeholder={t("banner.to")}
          onItemClick={(item) => {
            setKeyword2(item?.cityName);
            setDestinationLocationCode(item);
            handelUpdateFlightsData({
              id: flightId,
              key: "destination",
              value: item,
            });
            setOpenDrawer(false);
          }}
          keyword={keyword2}
          airports={getAirportByIataCodeApi2}
          setKeyword={setKeyword2}
          excludeCityCode={
            multiCity?.find((flight) => flight.id === flightId)?.origin
              ?.cityCode || originLocationCode?.cityCode
          }
        />
      )}
      {activeList !== "calendar" && (
        <>
          <Divider />
          <div className="btns-wrapper">
            <MainButton className="bigBtn" onClick={toggleDrawer(false)}>
              Cancel
            </MainButton>
            <MainButton
              onClick={() => {
                toggleDrawer(false)();
                redirectSearch();
              }}
              className="bigBtn primary-color"
            >
              Done
            </MainButton>
          </div>
        </>
      )}
    </Box>
  );

  const getEnv = true;

  /// Multi City
  const initialData = [
    {
      id: 1,
      origin: "",
      destination: "",
      originDate: "",
    },
  ];

  const [multiCity, setMultiCity] = useState(initialData);

  /// Update multi City

  const handelUpdateFlightsDataFromURL = () => {
    const startDate = searchParams.get("startDate");
    const originParam = searchParams.get("origin");

    // ---------- Single city (hotel-like case) ----------
    if (startDate) {
      setMultiCity([
        {
          id: 1,
          destination: searchParams.get("destination"),
          originDate: startDate,
          destinationDate: searchParams.get("endDate"),
        },
      ]);
      return;
    }

    // ---------- Multi-city flights ----------
    if (!originParam) return;

    const origins = originParam.split("~");
    const destinations = searchParams.get("destination")?.split("~") ?? [];
    const departureDates = searchParams.get("departure-date")?.split("~") ?? [];
    const returnDates = searchParams.get("return-date")?.split("~");

    const parseCity = (value) => {
      if (!value) return { cityCode: "", cityName: "" };
      const [cityCode, cityName] = value.split("-");
      return { cityCode, cityName };
    };

    const dataFromSearchURL = origins.map((origin, index) => ({
      id: index + 1,
      origin: parseCity(origin),
      destination: parseCity(destinations[index]),
      originDate: departureDates[index],
      ...(returnDates && {
        destinationDate: returnDates[index],
      }),
    }));

    setMultiCity(dataFromSearchURL);
  };

  useEffect(() => {
    handelUpdateFlightsDataFromURL();
  }, [
    searchParams.get("departure-date"),
    searchParams.get("origin"),
    searchParams.get("destination"),
  ]);

  const handleAddDestination = () => {
    if (multiCity.length === 1) {
      handelUpdateFlightsData({
        id: 1,
        key: "originDate",
        value: moment(new Date()).add(7, "days").format("YYYY-MM-DD"),
      });
    }
    if (multiCity.length < 4) {
      const flight = {
        id: multiCity.length + 1,
        origin: "",
        destination: "",
        originDate: moment(multiCity[multiCity.length - 1]?.originDate)
          .add(3, "days")
          .format("YYYY-MM-DD"),
      };
      setMultiCity([...multiCity, flight]);
    }
  };

  const handleRemoveDestination = (id) => {
    if (multiCity.length > 1) {
      const flights = multiCity
        .filter((i) => i.id !== id)
        .map((item, index) => ({ ...item, id: index + 1 }));
      setMultiCity(flights);
    }
  };

  const isQuickRouteActive = (route) => {
    const flight = multiCity[0];
    return (
      flight?.origin?.cityCode === route.origin.cityCode &&
      flight?.destination?.cityCode === route.destination.cityCode
    );
  };

  const handelUpdateFlightsData = ({ id, key, value }) => {
    const flightDetails = [...multiCity];

    flightDetails.map((flight, index) => {
      if (flight.id === id) {
        flight[key] = value;
        return flight;
      }
      if (
        flight.id > id &&
        key === "originDate" &&
        returnOption.currentOption === "Multi-city"
      ) {
        flight[key] = moment(flightDetails[index - 1]?.originDate)
          .add(3, "days")
          .format("YYYY-MM-DD");
        return flight;
      }
      return flight;
    });

    setMultiCity(flightDetails);
  };

  const applyQuickRoute = (route) => {
    const flightId = multiCity[0]?.id || 1;

    setActiveTab("flights");
    setShow(null);
    setOriginLocationCode(route.origin);
    setDestinationLocationCode(route.destination);
    addRecentAirport(route.origin);
    addRecentAirport(route.destination);
    setMultiCity((prev) =>
      prev.map((flight) =>
        flight.id === flightId
          ? {
              ...flight,
              origin: route.origin,
              destination: route.destination,
            }
          : flight
      )
    );
  };

  useEffect(() => {
    if (!presetRoute?.origin?.cityCode || !presetRoute?.destination?.cityCode) {
      return;
    }

    applyQuickRoute(presetRoute);
  }, [presetRoute?.nonce]);

  const clearFlightDetails = () => {
    const filteredFlightsDetails = multiCity.shift();
    setMultiCity([filteredFlightsDetails]);
  };

  const isBtnValid = Boolean(
    activeTab === "flights"
      ? multiCity.find((i) => i.origin === "") ||
          multiCity.find((i) => i.destination === "") ||
          multiCity.find((i) => i.originDate === "") ||
          (returnOption.currentOption !== "One-way"
            ? multiCity.find((i) => i.destinationDate === "")
            : false)
      : !destinationLocationCode?.cityCode ||
          multiCity.find((i) => i.originDate === "") ||
          multiCity.find((i) => i.destinationDate === "")
  );

  return (
    <>
      <Box mt={compact ? 0 : 2} className={compact ? "banner--compact" : ""}>
        {!compact && (
          <Box
            className="card card-above"
            display="flex"
            alignItems="center"
            flexDirection="row"
            justifyContent="center"
            flexWrap="wrap"
            gap={2}
          >
            {tabs.map((tab, index) => {
              const tabKey = tab.toLocaleLowerCase();
              const isHotelsDisabled = tabKey === "hotels";
              const isDisabled =
                isHotelsDisabled || (tabKey === "cars" && !getEnv);

              return (
                <Box
                  key={index}
                  className={`tab ${
                    isDisabled
                      ? "disabled"
                      : activeTab === tabKey
                      ? "active"
                      : "inactive"
                  }`}
                  onClick={() => {
                    if (isDisabled) return;
                    setActiveTab(tabKey);
                    setReturnOption({
                      ...returnOption,
                      currentOption: "Return",
                    });
                    clearFlightDetails();
                  }}
                >
                  {tabKey === "flights" ? (
                    <Airplate />
                  ) : tabKey === "hotels" ? (
                    <HotelIcon />
                  ) : tabKey === "cars" ? (
                    <DepartureBoardIcon />
                  ) : (
                    <DepartureBoardIcon />
                  )}

                  {translateTab(tab)}
                  {isHotelsDisabled && (
                    <span className="tab-coming-soon">
                      {t("banner.comingSoon")}
                    </span>
                  )}
                </Box>
              );
            })}
          </Box>
        )}
        <Box
          className={`${
            returnOption.currentOption !== "Return" ? " hide-returnField" : " "
          } card ${activeTab}
          `}
        >
          {!compact && (
            <div className="home-search-flare" aria-hidden="true">
              <span className="home-search-flare__ring home-search-flare__ring--tr" />
              <span className="home-search-flare__ring home-search-flare__ring--bl" />
            </div>
          )}
          {activeTab === "cars" ? (
            <CarsTab isMobile={isMobile} />
          ) : (
            <>
              <div className="d-flex flex-wrap search-filters">
                {activeTab === "flights" && (
                  <>
                    <DropDown
                      activeOption={returnOption.currentOption}
                      options={returnOption.options}
                      onClick={changeType}
                    />

                    <div className="mobile-view">
                      <Button onClick={toggleDrawer(true, "return")}>
                        {chooseType(returnOption.currentOption)}
                        {translateOption(
                          returnOption.options.find(
                            (item) => item.value === returnOption.currentOption
                          )
                        )}
                      </Button>
                      <Button onClick={toggleDrawer(true, "pass")}>
                        {t("banner.filters")}
                      </Button>
                    </div>
                  </>
                )}
                {activeTab === "flights" && (
                  <>
                    <DropDown
                      activeOption={classOption.currentOption}
                      options={classOption.options}
                      onClick={changeClass}
                    />

                    <DropDown
                      activeOption={stops.currentOption.value}
                      options={stops.options}
                      onClick={changeStops}
                    />
                  </>
                )}
                {activeTab === "flights" && (
                  <>
                    <DropDown
                      options={passerngersType}
                      options2={bagsType}
                      checkedBag={checkedBag}
                      onChangeRadio={() => {
                        setCheckedBag(!checkedBag);
                        handleUpdateFilters(
                          getSpecificFilter("Baggage"),
                          getSpecificFilter("Baggage").options[0]
                        );
                      }}
                      activeTab={activeTab}
                      onClickMinus={onClickMinus}
                      onClickPlus={onClickPlus}
                      hideFilter={hideFilter}
                      setActiveTab={setActiveTab}
                      className="checked-items"
                      redirectSearch={hideFilter && redirectSearch}
                    />
                  </>
                )}
                {activeTab === "hotels" && (
                  <HotelsTab
                    rooms={rooms}
                    setRooms={setRooms}
                    infoSource={infoSource}
                    setInfoSource={setInfoSource}
                    isSearchable={isSearchable}
                  />
                )}

                {activeTab === "flights" && (
                  <Box
                    className={`refundable-fare-option${
                      refundableFare ? " is-active" : ""
                    }`}
                    sx={{
                      display: { xs: "none", sm: "inline-flex" },
                    }}
                    onClick={() => {
                      setRefundableFare(!refundableFare);
                      handleUpdateFilters(
                        getSpecificFilter("Refundable Fare"),
                        getSpecificFilter("Refundable Fare").options[0]
                      );
                    }}
                  >
                    <Radio
                      checked={refundableFare}
                      size="small"
                      sx={{
                        p: 0,
                        mr: 0.75,
                        "& .MuiSvgIcon-root": {
                          fontSize: 16,
                        },
                      }}
                      color="default"
                    />
                    <span>{t("banner.refundableFare")}</span>
                  </Box>
                )}

                {showQuickRoutes && activeTab === "flights" && (
                  <button
                    type="button"
                    className={`quick-routes__toggle${
                      quickRoutesOpen ? " is-open" : ""
                    }`}
                    aria-expanded={quickRoutesOpen}
                    onClick={() => setQuickRoutesOpen((open) => !open)}
                  >
                    <span className="quick-routes__label">
                      {t("banner.quickRoutes")}
                    </span>
                    <span className="quick-routes__toggle-meta">
                      <span>
                        {quickRoutesOpen
                          ? t("banner.quickRoutesHide")
                          : t("banner.quickRoutesShow")}
                      </span>
                      <KeyboardArrowDownIcon className="quick-routes__chevron" />
                    </span>
                  </button>
                )}
              </div>

              {showQuickRoutes &&
                activeTab === "flights" &&
                quickRoutesOpen && (
                  <div className="quick-routes__list">
                    {QUICK_ROUTES.map((route) => (
                      <button
                        key={route.id}
                        type="button"
                        className={`quick-routes__chip${
                          isQuickRouteActive(route) ? " is-active" : ""
                        }`}
                        onClick={() => applyQuickRoute(route)}
                      >
                        <span>{route.origin.cityName}</span>
                        <Airplate />
                        <span>{route.destination.cityName}</span>
                      </button>
                    ))}
                  </div>
                )}

              <Box className="banner-multicity-stack">
              {returnOption.currentOption === "Multi-city" && (
                <Box
                  className="banner-multicity-actions"
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={2}
                  flexWrap="wrap"
                >
                  <Button
                    disabled={multiCity.length >= 4}
                    variant="contained"
                    color="secondary"
                    onClick={handleAddDestination}
                    sx={{ width: { xs: "100%", md: "auto" } }}
                  >
                    {t("banner.addDestination")}
                  </Button>

                  <button
                    disabled={isBtnValid}
                    className="search-btn btn"
                    onClick={redirectSearch}
                  >
                    {t("banner.letsGo")}
                  </button>
                </Box>
              )}
              <ClickAwayListener
                onClickAway={() => {
                  setShow(null);
                }}
              >
                <Box className="banner-flight-fields">
                  {multiCity?.map((flight, index) => (
                    <div
                      className={`d-flex banner-content${
                        show === "origin" + flight.id ||
                        show === "destination" + flight.id
                          ? " is-search-open"
                          : ""
                      }`}
                      key={flight?.id || index}
                    >
                      {returnOption.currentOption === "Multi-city" && (
                        <Typography
                          mb={1}
                          mt={1}
                          sx={{ display: { xs: "block", md: "none" } }}
                          fontWeight="bold"
                        >
                          {t("banner.trip", { number: index + 1 })}
                        </Typography>
                      )}
                      <div className="block-group">
                        {activeTab === "flights" ? (
                          <>
                            <Box
                              position="relative"
                              className="block-group-item"
                            >
                              <BannerInputSection
                                placeholder={t("banner.from")}
                                toggleDrawer={toggleDrawer(
                                  true,
                                  "departure",
                                  flight.id
                                )}
                                isMobile={isMobile}
                                excludeCityCode={flight.destination?.cityCode}
                                onSelect={(item) => {
                                  setShow("destination" + flight.id);
                                  setOriginLocationCode(item);
                                  handelUpdateFlightsData({
                                    id: flight.id,
                                    key: "origin",
                                    value: item,
                                  });
                                }}
                                show={show === "origin" + flight.id}
                                onClick={() => {
                                  setShow("origin" + flight.id);
                                  setFlightID(flight.id);
                                }}
                                selected={
                                  flight.origin?.cityName ||
                                  flight.origin?.cityCode
                                }
                                onClose={() =>
                                  handelUpdateFlightsData({
                                    id: flight.id,
                                    key: "origin",
                                    value: "",
                                  })
                                }
                              />
                              {flight?.origin && flight?.destination && (
                                <Box
                                  className="switch-icon"
                                  onClick={() => {
                                    const destination = flight.destination;

                                    handelUpdateFlightsData({
                                      id: flight.id,
                                      key: "destination",
                                      value: flight.origin,
                                    });

                                    handelUpdateFlightsData({
                                      id: flight.id,
                                      key: "origin",
                                      value: destination,
                                    });
                                  }}
                                >
                                  <SwitchLeftIcon />
                                </Box>
                              )}
                            </Box>
                            <Box className="block-group-item">
                              <BannerInputSection
                                placeholder={t("banner.to")}
                                toggleDrawer={toggleDrawer(
                                  true,
                                  "return-flight",
                                  flight.id
                                )}
                                isDestination
                                isMobile={isMobile}
                                excludeCityCode={
                                  flight.origin?.cityCode ||
                                  originLocationCode?.cityCode
                                }
                                onSelect={(item) => {
                                  setDestinationLocationCode(item);
                                  handelUpdateFlightsData({
                                    id: flight.id,
                                    key: "destination",
                                    value: item,
                                  });
                                  setShow("dateFrom");

                                  setFlightID(flight.id);
                                }}
                                show={show === "destination" + flight.id}
                                onClick={() => {
                                  setShow("destination" + flight.id);
                                  setFlightID(flight.id);
                                }}
                                selected={
                                  flight.destination?.cityName ||
                                  flight.destination?.cityCode
                                }
                                onClose={() =>
                                  handelUpdateFlightsData({
                                    id: flight.id,
                                    key: "destination",
                                    value: "",
                                  })
                                }
                              />
                            </Box>
                          </>
                        ) : (
                          <Box className="block-group-item">
                            <BannerInputSection
                              placeholder={t("banner.destination")}
                              toggleDrawer={toggleDrawer(
                                true,
                                "return-flight",
                                flight.id
                              )}
                              isMobile={isMobile}
                              onSelect={(item) => {
                                setDestinationLocationCode(item);
                                handelUpdateFlightsData({
                                  id: flight.id,
                                  key: "destination",
                                  value: item,
                                });
                                setShow("dateFrom");

                                setFlightID(flight.id);
                              }}
                              show={show === "destination" + flight.id}
                              onClick={() => {
                                setShow("destination" + flight.id);
                                setFlightID(flight.id);
                              }}
                              selected={
                                flight.destination?.cityCode ||
                                flight.destination
                              }
                              onClose={() =>
                                handelUpdateFlightsData({
                                  id: flight.id,
                                  key: "destination",
                                  value: "",
                                })
                              }
                            />
                          </Box>
                        )}

                        <>
                          <div className="block-group-item calendar-date">
                            <BannerInput
                              placeholder={
                                activeTab === "flights"
                                  ? t("banner.departureDate")
                                  : t("banner.checkIn")
                              }
                              onFocus={() => {
                                setShow("dateFrom");
                                setFlightID(flight.id);
                              }}
                              name="dateFrom"
                              onClick={() => {
                                if (!isMobile) {
                                  setShow("dateFrom");
                                  setFlightID(flight.id);
                                }
                              }}
                              isMobile={isMobile}
                              toggleDrawer={toggleDrawer(
                                true,
                                "calendar",
                                flight.id,
                                "departure"
                              )}
                              value={
                                flight.originDate &&
                                moment(flight.originDate).format("MMM Do YY")
                              }
                              readOnly
                              required
                            />
                            {(show === "dateTo" || show === "dateFrom") &&
                              flightId === flight.id && (
                                <DatePicker
                                  isMobile={isMobile}
                                  toggleDrawer={toggleDrawer(false)}
                                  setdepartureDate={(date) => {
                                    handelUpdateFlightsData({
                                      id: flight.id,
                                      key: "originDate",
                                      value: date,
                                    });
                                  }}
                                  setReturnDate={setReturnDate}
                                  onSelect={(dates) => {
                                    handelUpdateFlightsData({
                                      id: flight.id,
                                      key: "originDate",
                                      value: dates.startDate,
                                    });
                                    handelUpdateFlightsData({
                                      id: flight.id,
                                      key: "destinationDate",
                                      value: dates.endDate,
                                    });
                                  }}
                                  onHide={() => {
                                    setShow(false);
                                  }}
                                  disabled={
                                    returnOption.currentOption !== "Return"
                                  }
                                  returnDate={flight?.destinationDate}
                                  departureDate={flight.originDate}
                                  show={show}
                                  setShow={setShow}
                                  flightType={returnOption.currentOption}
                                  dateDifference={moment(
                                    flight.originDate
                                  ).diff(
                                    moment(multiCity[index - 1]?.originDate),
                                    "days"
                                  )}
                                />
                              )}
                          </div>

                          {(returnOption.currentOption === "Return" ||
                            activeTab === "hotels") && (
                            <div className="block-group-item calendar-date">
                              <BannerInput
                                placeholder={
                                  activeTab === "flights"
                                    ? t("banner.return")
                                    : t("banner.checkOut")
                                }
                                onFocus={() => {
                                  setShow("dateTo");
                                  setFlightID(flight.id);
                                }}
                                onClick={() => {
                                  if (!isMobile) {
                                    setShow("dateTo");
                                    setFlightID(flight.id);
                                  }
                                }}
                                isMobile={isMobile}
                                toggleDrawer={toggleDrawer(true, "calendar")}
                                value={
                                  flight.destinationDate
                                    ? moment(flight.destinationDate).format(
                                        "MMM Do YY"
                                      )
                                    : ""
                                }
                                readOnly
                                required
                                flightType={returnOption.currentOption}
                              />
                            </div>
                          )}
                        </>
                      </div>

                      {returnOption.currentOption === "Multi-city" ? (
                        multiCity.length > 2 && (
                          <IconButton
                            onClick={() => handleRemoveDestination(flight.id)}
                            sx={{
                              height: "40px",
                              mt: 0.5,
                              width: "40px",
                              ml: 1,
                              position: { xs: "absolute", md: "relative" },
                              right: { xs: "20px", md: "0px" },
                            }}
                            size="small"
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        )
                      ) : (
                        <button
                          disabled={isBtnValid}
                          className="search-btn btn"
                          onClick={redirectSearch}
                        >
                          {t("banner.letsGo")}
                        </button>
                      )}
                    </div>
                  ))}
                </Box>
              </ClickAwayListener>
              </Box>
            </>
          )}
        </Box>

        {loading && (
          <LinearProgress
            className="progress-bar-calendar"
            sx={{
              mb: 2,

              height: "2px",
              position: "absolute",
              width: "100%",
              bottom: "-16px",
              left: "0px",
            }}
            color="secondary"
          />
        )}
      </Box>
      <Modal
        className={`${
          (activeList === "departure" || activeList === "return-flight") &&
          "border-modal"
        } ${activeList === "calendar" && "full-size-modal"}`}
        toggleDrawer={toggleDrawer}
        openDrawer={openDrawer}
        sx={{
          "& .MuiDrawer-paperAnchorBottom": {
            minHeight: "260px",
          },
        }}
      >
        {list()}
      </Modal>
    </>
  );
};

export default Banner;
